function callLoadMoreAjax(url, numberOfResultsToUse, $divToAppendResultTo, $buttonToHide, replaceContent, currentguid) {
    $.ajax({
        url: url,
        success: function (data) {
            var $result = $(data);
            var $currentList = $divToAppendResultTo;
            var showmore = $divToAppendResultTo.find('#hideshowmorerecords').remove();

            if (!!replaceContent && replaceContent == "Y") {
                $currentList.empty();
                if (!!currentguid && !!$buttonToHide.data("currentguid")) {
                    $buttonToHide.data('currentguid', currentguid)                    
                }
            }

            $currentList.append($($result).hide());
            $($result).slideDown();

            $showmore = $result.filter('#hideshowmorerecords').val();
            if (!($showmore === "Y"))
                $buttonToHide.hide();
            else
                $buttonToHide.show();
        }
    });
}

window.callLoadMoreAjax = callLoadMoreAjax;